angular.module('mtic.components.custom_calendar', [])
.directive('customCalendar', function (
      $interval, 
      $timeout,
      TIMING_CONSTANTS,
      $log,
      EventManager
) {
      return {
            templateUrl: 'template.html',
            scope: {
                  calendarEvents: '=?',
                  selectedDate:'=?',
                  showSelectedDate:'=?'
            },
            link: function (scope,element,attrs) {
                scope.calendar = {
                    rows:7,
                    months:["January","February","March","April","May","June","July","August","September","October","November","December"],
                    days:["Mon","Tue","Wed","Thu","Fri","Sat","Sun"],
                    columns:6,
                    currentMonth:0,
                    dateObjects:[],
                    currentYear:2018
                }

                var eventManager = new EventManager('teacherStudentsAgenda', scope);
                var today = {
                    year:1,
                    month:1,
                    day:1
                }
                scope.goToPreviousMonth = function(){
                    scope.calendar.currentMonth -=1;
                    if(scope.calendar.currentMonth<0){
                        scope.calendar.currentMonth = 11;
                        scope.calendar.currentYear-=1;
                    }

                    updateCalendar(scope.calendar.currentYear,scope.calendar.currentMonth);
                }

                scope.goToNextMonth = function(){
                    scope.calendar.currentMonth +=1;
                    if(scope.calendar.currentMonth>11){
                        scope.calendar.currentMonth = 0;
                        scope.calendar.currentYear+=1;
                    }

                    updateCalendar(scope.calendar.currentYear,scope.calendar.currentMonth);
                }

                var getEventsForCurrentDay = function(year,month,date){
                    var currentEvents = [];
                    angular.forEach(scope.calendarEvents,function(event){
                        if(event.eventDate.date()===date && event.eventDate.month()===month && event.eventDate.year()===year){
                            currentEvents.push(event);
                        }
                    });

                    return currentEvents;
                }

                var updateCalendar = function(year,month){
                    var date = moment({y:year,M:month,d:1});
                    // date.setDate(1);
                    var totalDaysInCurrentMonth  = (moment({y:year,M:date.month()})).daysInMonth();
                    var firstDayInMonth = date.day();
                    //adjustment for monday being the beginning
                    if(firstDayInMonth===0){
                        firstDayInMonth = 7;
                    }
                    scope.calendar.dateObjects = [];
                    var events;
                    for(var i=1;i<=totalDaysInCurrentMonth;i++){
                        events = getEventsForCurrentDay(scope.calendar.currentYear,scope.calendar.currentMonth,i);
                        var dateObject = {day:i,events:events,month:scope.calendar.currentMonth,year:scope.calendar.currentYear};
                        dateObject.isToday = (today.year===scope.calendar.currentYear && today.month===scope.calendar.currentMonth && today.day===i);
                        scope.calendar.dateObjects.push(dateObject);
                    }

                    var totalDaysInLastMonth = (moment({y:date.year(),M:date.month()-1})).daysInMonth();
                    for(i=firstDayInMonth-1;i>0;i--){
                        events = getEventsForCurrentDay(scope.calendar.currentYear,scope.calendar.currentMonth-1,i);
                        var prevMonthDateObject = {day:totalDaysInLastMonth,events:events,month:scope.calendar.currentMonth-1};
                        scope.calendar.dateObjects.unshift(prevMonthDateObject);
                        totalDaysInLastMonth--;
                    }

                    var emptyDateBoxCount = (scope.calendar.rows * scope.calendar.columns) - scope.calendar.dateObjects.length;
                    for(i=1;i<=emptyDateBoxCount;i++){
                        events = getEventsForCurrentDay(scope.calendar.currentYear,scope.calendar.currentMonth+1,i);
                        var nextMonthDateObject = {day:i,events:events,month:scope.calendar.currentMonth+1};
                        scope.calendar.dateObjects.push(nextMonthDateObject);
                    }
                }

                scope.selectToday = function(){
                    if(!(scope.calendar.currentYear===today.year && scope.calendar.currentMonth === today.month)){
                        scope.calendar.currentYear = today.year;
                        scope.calendar.currentMonth = today.month;
                        updateCalendar(today.year,today.month);
                    }
                }

                scope.selectDate =function(dateObject,$event){
                    $event.stopPropagation();
                    if(dateObject && dateObject.month===scope.calendar.currentMonth){
                        var date = moment().year(dateObject.year).month(dateObject.month).date(dateObject.day)
                        scope.selectedDate = date;
                        eventManager.broadcast("calendar:date:selected",date);
                    }
                }

                scope.isSelectedDateMatch = function(dateObject){
                    var matched = false;
                    if(scope.selectedDate && scope.showSelectedDate){
                        var date = moment(scope.selectedDate)
                        if(date.date()===dateObject.day && date.month()===dateObject.month && date.year()===dateObject.year){
                            matched = true;
                        }
                    }

                    return matched;
                }

                var initialize = function(){
                    // $log.log(scope.calendarEvents);
                    var date = moment();
                    scope.calendar.currentMonth = date.month();
                    scope.calendar.currentYear = date.year();
                    today = {
                        year:date.year(),
                        month:date.month(),
                        day:date.date()
                    }
                    updateCalendar(scope.calendar.currentYear,scope.calendar.currentMonth);
                    $timeout(function(){
                        var totalViewableWidth = element.parent()[0].parentElement.clientWidth;
                        var calendarElement = document.getElementById("custom-calendar");//calendar-table
                        var calendarTable = document.getElementById("calendar-table");//calendar-table
                        if(totalViewableWidth>calendarTable.clientWidth){
                            calendarElement.style.marginLeft = ((totalViewableWidth-calendarTable.clientWidth) /2 )+"px";
                        }
                    },100);
                    
                }

                initialize();

                eventManager.listen("calendarEvents:updated",function(e,events){
                    scope.calendarEvents = events;
                    updateCalendar(scope.calendar.currentYear,scope.calendar.currentMonth);
                });
            }
      }
});
